module.exports = __webpack_public_path__ + "img/MX-A012023A-AS.e400dba4.png";